// Page Builder 2026 — Video Row block
//
// Three autoplaying clips would be a heavy thing to put on page load, so the file
// lives on a data attribute and is only attached once the band scrolls into view.
// Leaving the viewport pauses playback again — decoding video nobody is looking at
// is wasted battery.
//
// With no IntersectionObserver, or no JS at all, the cover images stand in and
// nothing downloads. That is a reasonable resting state for a decorative band.

const SELECTOR = '.block-video-row__video[data-video-row-src]';

function startVideo(video) {
  if (!video.src) {
    video.src = video.dataset.videoRowSrc;
  }

  // play() rejects if the browser declines — muted autoplay is normally allowed,
  // but a failure here should not throw past this point.
  const played = video.play();

  if (played && typeof played.catch === 'function') {
    played.catch(() => {});
  }
}

function init() {
  const videos = document.querySelectorAll(SELECTOR);

  if (!videos.length) {
    return;
  }

  if (!('IntersectionObserver' in window)) {
    videos.forEach(startVideo);

    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          startVideo(entry.target);
        } else if (entry.target.src) {
          entry.target.pause();
        }
      });
    },
    { rootMargin: '200px 0px' }
  );

  videos.forEach((video) => observer.observe(video));
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
